export default {
      id: "administration-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#administration-usage",
      toString: function () {
        return this.url;
      }
    }